// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"196":"ee8b1517","218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"196":"84e5f661343fe749ea8a","218":"d38cc9eb87855ca0bd02","691":"0e3a62d9a225317a6ce7"}[chunkId] + ".js";
};